import httpDriver from 'app/utils/httpDriver';
import { TMutation, TQuery } from 'app/Requests/types';
import { apiRoutes } from 'tweets/utils/apiRoutes';
import { checkTranslated } from 'app/utils/helpers';

export const queryName = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.get('');
  return data;
};

export const getTweetDetails = async ({ queryKey }: TQuery): Promise<any> => {
  const { body } = queryKey[1];
  const { data } = await httpDriver.post(apiRoutes.tweetDetails, body);
  return data?.payload?.records;
};

export const deleteIncompleteTweets = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteTweet, {
    data: { ids: [+id] },
  });
  return { ...data, successMessage };
};

export const getRegrabTweet = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.regrabTweet, {
    ids: [+id],
  });
  return { ...data, successMessage };
};

export const getRegrabTweetReplies = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.regrabTweetReplies, {
    tweet_id: id,
  });
  return { ...data, successMessage };
};

export const getRegrabTweetRepliesConversations = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.regrabTweetRepliesConversations,
    {
      tweet_id: id,
    },
  );
  return { ...data, successMessage };
};

export const getTweetTypes = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tweetTypes);
  return (
    data?.payload?.records.map((opt: any) => {
      return { value: opt.id, label: checkTranslated(opt?.name, opt?.name_ar) };
    }) || []
  );
};

export const changeTweetQuoteCategory = async ({
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.changeTweetQuotes, body);
  return data;
};

export const changeTweetReplyCategory = async ({
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.changeTweetReplies, body);
  return data;
};

export const loadConversationReplies = async ({
  id,
  is_sample,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tweetReplayConversation, {
    tweet_id: +id,
    is_sample,
  });
  return { ...data };
};

export const tweetSentimentAnalysisAdd = async ({
  tweet_id,
  words,
  hashtags,
  category,
}: TMutation<{
  words: string[];
  category: string;
  influencer_id: number;
}>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.tweetSentimentAnalysisAdd, {
    tweet_id,
    words,
    hashtags,
    category,
  });
  return data;
};

export const addTweet = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.addTweet, body);
  return data;
};

export const getMostFreqWords = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.mostFrequentWords,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getMostFreqHashtags = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.mostFrequentHashtags,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getColumnsSentimentData = async ({
  id,
  isInfluencerModule,
  type,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.showTweetSentiment, {
    category: type,
    tweet_id: Number(id),
  });
  return data?.payload?.records;
};
export const updateSentimentAnalysis = async ({
  isInfluencerModule,
  id,
  sets,
  words,
  hashtags,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.updateTweetSentiment, {
    tweet_id: Number(id),
    sets,
    words,
    hashtags,
  });
  return data;
};
